// extracted by mini-css-extract-plugin
export var aiStarIcon = "_c3-4";
export var closeButton = "_c3-6";
export var dismissButton = "_c3-3";
export var editImageWithAiContainer = "_c3-8";
export var imageUploadWrapper = "_c3-7";
export var misspelledWord = "_c3-5";
export var spellCheckContainer = "_c3-2";
export var spin = "_c3-1";
export var spinning = "_c3-0";